// extracted by mini-css-extract-plugin
export var borderRadius = "_ae-4";
export var large = "_ae-3";
export var logoContainer = "_ae-0";
export var nameLogo = "_ae-2";
export var small = "_ae-1";